import { render } from "./CallSidePanel.vue.js?vue&type=template&id=2adc90f3!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallSidePanel.vue?vue&type=template&id=2adc90f3"
import script from "./CallSidePanel.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallSidePanel.vue?vue&type=script&lang=js"
export * from "./CallSidePanel.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallSidePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/panels/CallSidePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2adc90f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2adc90f3', __exports__)) {
    api.reload('2adc90f3', __exports__)
  }
  
  module.hot.accept("./CallSidePanel.vue.js?vue&type=template&id=2adc90f3!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallSidePanel.vue?vue&type=template&id=2adc90f3", () => {
    api.rerender('2adc90f3', render)
  })

}


export default __exports__